export function ToAccountList(_accountList: any, language = "en") {
  const accountList = [];
  if (_accountList !== null) {
    for (let i = 0; i < _accountList.length; i++) {
      const accountData = {
        id: _accountList[i].id,
        code: _accountList[i].code,
        name: {
          locale: language === "en" ? _accountList[i].nameEnglish : _accountList[i].nameThai,
          thai: _accountList[i].nameThai,
          english: _accountList[i].nameEnglish,
        },
        accountTypeSubId: _accountList[i].accountTypeSubId,
        taxIncomeTypeId: _accountList[i].taxIncomeTypeId,
        whtValue: _accountList[i].whtValue,
        referenceTypeId: _accountList[i].referenceTypeId,
        subReferenceTypeId: _accountList[i].subReferenceTypeId,
        isMain: _accountList[i].isMain,
        suggestAccountVatType: _accountList[i].accountVatType,
        status: "null",
      };
      accountList.push(accountData);
    }
  }
  return accountList;
}

export function ToAccountMonitoringList(_accountMonitoringLis: any) {
  const accountMonitoringLis: any = [];
  if (_accountMonitoringLis.length > 0) {
    _accountMonitoringLis.forEach((item: any) => {
      const accountMonitoringData = {
        accountId: item.accountId,
        name: item.name,
        code: item.code,
        accountTypeSecondaryName: item.accountTypeSecondaryName,
        total: item.total,
        changeFormType: item.changeFormType,
        changeFormValue: item.changeFormValue,
      };
      accountMonitoringLis.push(accountMonitoringData);
    });
  }
  return accountMonitoringLis;
}
